(()=>{try{if(!sessionStorage.getItem('norvelia-intro-seen')){sessionStorage.setItem('norvelia-intro-seen','1')}else{document.documentElement.classList.add('return-visit')}}catch(e){}})();

document.addEventListener('click',function(e){var btn=e.target.closest('.mobile-menu-toggle');if(!btn)return;var nav=document.getElementById('primary-nav');if(!nav)return;var open=nav.classList.toggle('is-open');btn.setAttribute('aria-expanded',String(open));});

/* Progressive enhancement: never block navigation or checkout. */
(()=>{const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(reduce)return;const nodes=[...document.querySelectorAll('[data-nv-reveal]')];if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('nv-in-view');observer.unobserve(entry.target)}})},{threshold:.08});nodes.forEach(node=>observer.observe(node));document.documentElement.classList.add('nv-motion-ready')}else{nodes.forEach(node=>node.classList.add('nv-in-view'))}let scheduled=false;window.addEventListener('scroll',()=>{if(!scheduled){requestAnimationFrame(()=>{document.documentElement.classList.toggle('nv-scrolled',window.scrollY>40);scheduled=false});scheduled=true}},{passive:true});document.addEventListener('keydown',e=>{if(e.key==='Escape'){const nav=document.getElementById('primary-nav');const btn=document.querySelector('.mobile-menu-toggle');if(nav&&btn){nav.classList.remove('is-open');btn.setAttribute('aria-expanded','false')}}});})();

/* V32: Product gallery, variant, zoom, quantity; native Shopify add-to-cart remains the fallback. */
(()=>{
  function initProduct(root){
    if(root.dataset.nvGalleryReady==='true')return;
    root.dataset.nvGalleryReady='true';
    const main=root.querySelector('[data-nv-main-image] img');
    const thumbs=[...root.querySelectorAll('[data-nv-image]')];
    const variant=root.querySelector('[data-nv-variant]');
    const price=root.querySelector('[data-nv-price]');
    const compare=root.querySelector('[data-nv-compare]');
    const stock=root.querySelector('[data-nv-stock]');
    const buy=root.querySelector('[data-nv-buy]');
    const buyLabel=root.querySelector('[data-nv-buy-label]');
    const counter=root.querySelector('[data-nv-gallery-counter]');
    const zoom=root.querySelector('[data-nv-zoom-dialog]');
    const zoomImg=root.querySelector('[data-nv-zoom-image]');
    const qty=root.querySelector('.nv-quantity');
    let currentIndex=thumbs.findIndex(btn=>btn.getAttribute('aria-pressed')==='true');
    if(currentIndex<0)currentIndex=0;
    const photoTotal=thumbs.length;
    const updateCounter=()=>{
      if(!counter)return;
      counter.textContent=currentIndex>=0 && photoTotal?`${String(currentIndex+1).padStart(2,'0')} / ${String(photoTotal).padStart(2,'0')}`:'FOTO DA OPÇÃO';
    };
    const showImage=(url,button)=>{
      if(!main || !url)return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src=url;
      currentIndex=button?thumbs.indexOf(button):-1;
      thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      if(zoomImg && zoom.open)zoomImg.src=url;
      updateCounter();
    };
    thumbs.forEach(btn=>btn.addEventListener('click',()=>showImage(btn.dataset.nvImage,btn)));
    const changePhoto=(step)=>{
      if(!thumbs.length)return;
      const next=currentIndex<0?(step>0?0:thumbs.length-1):(currentIndex+step+thumbs.length)%thumbs.length;
      const thumb=thumbs[next];
      showImage(thumb.dataset.nvImage,thumb);
      thumb.scrollIntoView?.({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest',inline:'nearest'});
    };
    root.querySelector('[data-nv-gallery-prev]')?.addEventListener('click',()=>changePhoto(-1));
    root.querySelector('[data-nv-gallery-next]')?.addEventListener('click',()=>changePhoto(1));
    function updateVariant(changeUrl=false){
      if(!variant)return;
      const selected=variant.selectedOptions[0];
      if(!selected)return;
      const available=selected.dataset.available==='true';
      const published=root.dataset.nvProductPublished!=='false';
      if(price)price.textContent=selected.dataset.price||'';
      if(compare){
        compare.hidden=!selected.dataset.compareAt;
        compare.replaceChildren();
        if(selected.dataset.compareAt){
          const strike=document.createElement('s');
          strike.textContent=selected.dataset.compareAt;
          compare.append(document.createTextNode('De '),strike);
        }
      }
      if(stock){stock.dataset.inStock=String(published&&available);stock.textContent=!published?'Em preparação':available?'Disponível':'Indisponível';}
      if(buy)buy.disabled=!(published&&available);
      if(buyLabel)buyLabel.textContent=!published?'PRODUTO EM PREPARAÇÃO':available?'ADICIONAR À SACOLA':'ESGOTADO';
      if(selected.dataset.image){
        const thumb=thumbs.find(btn=>btn.dataset.nvImageId===selected.dataset.imageId);
        showImage(selected.dataset.image,thumb);
      }
      if(changeUrl){
        try{const url=new URL(location.href);url.searchParams.set('variant',variant.value);history.replaceState({},'',url);}catch(e){}
      }
    }
    variant?.addEventListener('change',()=>updateVariant(true));
    variant && updateVariant(false);
    const adjust=delta=>{
      if(!qty)return;
      const value=Number.parseInt(qty.value,10);
      qty.value=String(Math.max(1,(Number.isFinite(value)?value:1)+delta));
    };
    root.querySelector('[data-nv-p30-qty-minus]')?.addEventListener('click',()=>adjust(-1));
    root.querySelector('[data-nv-p30-qty-plus]')?.addEventListener('click',()=>adjust(1));
    qty?.addEventListener('change',()=>{
      const value=Number.parseInt(qty.value,10);
      qty.value=String(Math.max(1,Number.isFinite(value)?value:1));
    });
    const openZoom=()=>{
      if(!zoom || !zoomImg || !main?.src)return;
      zoomImg.src=main.src;
      if(!zoom.open && typeof zoom.showModal==='function')zoom.showModal();
    };
    root.querySelector('[data-nv-zoom-trigger]')?.addEventListener('click',openZoom);
    root.querySelector('[data-nv-zoom-close]')?.addEventListener('click',()=>zoom?.close());
    zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();});
    updateCounter();
  }
  function init(container=document){container.querySelectorAll('[data-nv-product]').forEach(initProduct);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

/* V14 mobile menu: scoped to the new header; no dependency on old navigation. */
(()=>{const root=document.querySelector('[data-nv-header]');if(!root)return;const panel=root.querySelector('#nv-mobile-panel');const overlay=root.querySelector('.nv-mobile-overlay');const trigger=root.querySelector('[data-nv-menu-open]');if(!panel||!overlay||!trigger)return;let previousFocus=null;function setOpen(open){panel.classList.toggle('is-open',open);panel.setAttribute('aria-hidden',String(!open));panel.inert=!open;overlay.hidden=!open;trigger.setAttribute('aria-expanded',String(open));trigger.setAttribute('aria-label',open?'Fechar menu':'Abrir menu');document.body.style.overflow=open?'hidden':'';if(open){previousFocus=document.activeElement;panel.querySelector('[data-nv-menu-close]')?.focus()}else{(previousFocus||trigger).focus()}}trigger.addEventListener('click',()=>setOpen(trigger.getAttribute('aria-expanded')!=='true'));root.querySelectorAll('[data-nv-menu-close]').forEach(el=>el.addEventListener('click',()=>setOpen(false)));document.addEventListener('keydown',e=>{if(e.key==='Escape'&&trigger.getAttribute('aria-expanded')==='true')setOpen(false);if(e.key==='Tab'&&trigger.getAttribute('aria-expanded')==='true'){const focusables=[...panel.querySelectorAll('a,button,input,summary')].filter(x=>x.getClientRects().length);if(!focusables.length)return;const first=focusables[0],last=focusables.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});window.addEventListener('resize',()=>{if(window.innerWidth>850&&trigger.getAttribute('aria-expanded')==='true')setOpen(false)})})();

/* V32: Optional ViaCEP assistance. Manual address entry always remains available. */
(()=>{
  const digits=value=>String(value||'').replace(/\D+/g,'');
  const maskCep=value=>digits(value).slice(0,8).replace(/(\d{5})(\d)/,'$1-$2');
  const maskPhone=value=>{
    const d=digits(value).slice(0,11);
    if(d.length<=10)return d.replace(/(\d{2})(\d)/,'($1) $2').replace(/(\d{4})(\d)/,'$1-$2');
    return d.replace(/(\d{2})(\d)/,'($1) $2').replace(/(\d{5})(\d)/,'$1-$2');
  };
  document.addEventListener('input',event=>{
    const field=event.target.closest('[data-nv-mask]');
    if(!field)return;
    if(field.dataset.nvMask==='cep')field.value=maskCep(field.value);
    if(field.dataset.nvMask==='phone')field.value=maskPhone(field.value);
  });
  let lastAuto={};
  let lastLookedUp='';
  async function lookupCep(manual=false){
    const cepField=document.querySelector('[data-nv-cep]');
    const status=document.querySelector('[data-nv-cep-status]');
    if(!cepField)return;
    const cep=digits(cepField.value);
    if(cep.length!==8){
      if(manual && status){status.textContent='Informe um CEP com 8 dígitos.';cepField.focus();}
      return;
    }
    if(cep===lastLookedUp)return;
    if(status)status.textContent='Buscando endereço…';
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),6500);
    try{
      const response=await fetch('https://viacep.com.br/ws/'+cep+'/json/',{signal:controller.signal});
      if(!response.ok)throw new Error('CEP indisponível');
      const data=await response.json();
      if(data.erro)throw new Error('CEP não localizado');
      // A response for a previous CEP should never overwrite the new CEP.
      if(digits(cepField.value)!==cep)return;
      const fill=(selector,value)=>{
        const input=document.querySelector(selector);
        if(!input||!value)return;
        if(!input.value || input.value===lastAuto[selector]){
          input.value=value;
          lastAuto[selector]=value;
        }
      };
      fill('[data-nv-address]',data.logradouro);
      fill('[data-nv-neighborhood]',data.bairro);
      fill('[data-nv-city]',data.localidade);
      fill('[data-nv-state]',data.uf?.toUpperCase());
      lastLookedUp=cep;
      if(status)status.textContent='Endereço encontrado. Confira os dados e informe o número.';
    }catch(e){
      if(status)status.textContent='Não foi possível consultar o CEP. Preencha o endereço manualmente.';
    }finally{clearTimeout(timeout);}
  }
  document.addEventListener('click',event=>{if(event.target.closest('[data-nv-cep-trigger]'))lookupCep(true);});
  document.addEventListener('blur',event=>{if(event.target.matches('[data-nv-cep]')&&digits(event.target.value).length===8)lookupCep();},true);
  document.addEventListener('input',event=>{if(event.target.matches('[data-nv-cep]'))lastLookedUp='';});
})();

/* V32: Cart quantities, coupon and checkout handoff use the real Shopify Ajax Cart API. */
(()=>{
  const root=document.querySelector('.nv-luxury-checkout');
  const form=document.getElementById('nv-luxury-cart-form');
  if(!root||!form)return;
  const summary=root.querySelector('.nv-luxury-summary');
  const feedback=root.querySelector('[data-nv-cart-status]');
  const shopRoot=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  const cardsContainer=root.querySelector('#nv-order-items');
  const currencyFormat=(cents,currency='BRL')=>{
    try{return new Intl.NumberFormat(document.documentElement.lang||'pt-BR',{style:'currency',currency}).format((Number(cents)||0)/100);}
    catch(e){return 'R$ '+((Number(cents)||0)/100).toFixed(2).replace('.',',');}
  };
  const status=message=>{if(feedback)feedback.textContent=message||'';};
  const qtyFields=()=>[...root.querySelectorAll('.nv-summary-qty-row input[name="updates[]"]')];
  function payloadAttributes(){
    const attrs={};
    form.querySelectorAll('[name^="attributes["]').forEach(input=>{
      const match=input.name.match(/^attributes\[(.*)\]$/);
      if(match)attrs[match[1]]=input.value||'';
    });
    return attrs;
  }
  async function post(path,body){
    const response=await fetch(shopRoot+path,{
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    });
    const result=await response.json().catch(()=>({}));
    if(!response.ok||result.status>=400)throw Error(result.description||result.message||'A atualização não foi concluída.');
    return result;
  }
  function renderCart(cart){
    if(!cart||!Array.isArray(cart.items))return false;
    if(cart.item_count===0){window.location.reload();return true;}
    const available=[...cardsContainer.querySelectorAll('[data-nv-line-key]')];
    const arranged=[];
    for(const item of cart.items){
      let i=available.findIndex(card=>card.dataset.nvLineKey===item.key);
      if(i<0)i=available.findIndex(card=>card.dataset.nvVariantId===String(item.variant_id));
      if(i<0)return false; // Never reassign a price or variant to an unrelated card.
      const card=available.splice(i,1)[0];
      card.dataset.nvLineKey=item.key;
      card.dataset.nvVariantId=String(item.variant_id);
      const field=card.querySelector('input[name="updates[]"]');
      if(field){field.value=String(item.quantity);field.dataset.nvConfirmedQuantity=String(item.quantity);}
      const amount=card.querySelector('[data-nv-line-price]');
      if(amount)amount.textContent=currencyFormat(item.final_line_price,cart.currency);
      arranged.push(card);
    }
    available.forEach(card=>card.remove());
    arranged.forEach(card=>cardsContainer.appendChild(card));
    const set=(selector,value)=>{const node=root.querySelector(selector);if(node)node.textContent=value;};
    set('[data-nv-cart-count]',String(cart.item_count));
    set('[data-nv-subtotal]',currencyFormat(cart.items_subtotal_price,cart.currency));
    set('[data-nv-total]',currencyFormat(cart.total_price,cart.currency));
    set('[data-nv-mobile-total]',currencyFormat(cart.total_price,cart.currency));
    const count=root.querySelector('.nv-bag-count');
    if(count)count.textContent=String(cart.item_count);
    const discountRow=root.querySelector('[data-nv-discount-row]');
    if(discountRow){
      discountRow.hidden=!(cart.total_discount>0);
      set('[data-nv-discount]','−'+currencyFormat(cart.total_discount,cart.currency));
    }
    return true;
  }
  let debounce;
  let queue=Promise.resolve();
  let criticalError=false;
  function enqueue(work){
    queue=queue.catch(()=>{}).then(work);
    return queue;
  }
  async function updateField(field){
    const card=field.closest('[data-nv-line-key]');
    if(!card || !card.isConnected)return;
    const desired=Math.max(0,Math.floor(Number(field.value)||0));
    const confirmed=Math.max(0,Number(field.dataset.nvConfirmedQuantity)||0);
    if(desired===confirmed)return;
    const buttons=[...card.querySelectorAll('.nv-summary-qty-row button')];
    field.disabled=true;
    buttons.forEach(btn=>btn.disabled=true);
    try{
      status('Atualizando sua sacola…');
      const cart=await post('cart/change.js',{id:card.dataset.nvLineKey,quantity:desired});
      if(!renderCart(cart)){criticalError=true;throw Error('O conteúdo da sacola mudou. Atualize a página para conferir o pedido.');}
      status('Sacola atualizada.');
    }catch(error){
      field.value=String(confirmed);
      status(error.message||'Erro ao atualizar. Tente novamente.');
      throw error;
    }finally{field.disabled=false;buttons.forEach(btn=>btn.disabled=false);}
  }
  function flush(){
    clearTimeout(debounce);
    return enqueue(async()=>{
      if(criticalError)throw Error('Atualize a página para conferir sua sacola.');
      for(const field of qtyFields()){
        if(field.isConnected && field.value!==field.dataset.nvConfirmedQuantity)await updateField(field);
      }
    });
  }
  function schedule(){
    clearTimeout(debounce);
    debounce=setTimeout(()=>flush().catch(()=>{}),350);
  }
  root.addEventListener('click',event=>{
    const btn=event.target.closest('[data-nv-qty]');
    if(!btn)return;
    const input=btn.parentElement.querySelector('input[name="updates[]"]');
    if(!input||input.disabled)return;
    const current=Math.max(0,Number.parseInt(input.value,10)||0);
    input.value=String(Math.max(0,current+(btn.dataset.nvQty==='plus'?1:-1)));
    schedule();
  });
  root.addEventListener('change',event=>{
    if(event.target.matches('.nv-summary-qty-row input[name="updates[]"]'))schedule();
  });
  async function saveAttributes(){
    await flush();
    const cart=await post('cart/update.js',{attributes:payloadAttributes()});
    if(!cart.item_count)throw Error('Sua sacola está vazia.');
    if(!renderCart(cart))throw Error('Atualize a página e confirme os itens antes de pagar.');
    return cart;
  }
  form.addEventListener('submit',async event=>{
    const button=event.submitter;
    if(!button||button.name!=='checkout')return; // Native update remains available.
    event.preventDefault();
    if(!form.reportValidity())return;
    button.disabled=true;
    status('Conferindo a sacola e preparando o pagamento…');
    try{
      await saveAttributes();
      window.location.assign(shopRoot+'checkout');
    }catch(error){
      status((error.message||'Não foi possível continuar.')+' Confira e tente novamente.');
      // Never bypass failed saves or navigate to payment with unconfirmed quantities.
      button.disabled=false;
    }
  });
  const coupon=summary?.querySelector('[data-nv-coupon-form]');
  coupon?.addEventListener('submit',async event=>{
    event.preventDefault();
    const input=coupon.querySelector('[name="discount"]');
    const code=(input?.value||'').trim();
    const feedbackCoupon=coupon.querySelector('[data-nv-coupon-status]');
    const btn=coupon.querySelector('button[type="submit"]');
    if(!code){if(feedbackCoupon)feedbackCoupon.textContent='Digite um cupom.';return;}
    if(btn)btn.disabled=true;
    if(feedbackCoupon)feedbackCoupon.textContent='Verificando cupom com a Shopify…';
    try{
      await flush();
      const cart=await post('cart/update.js',{discount:code});
      if(!renderCart(cart))throw Error('Atualize a página para conferir seus valores.');
      // Applicability is reported by Shopify. Never invent a successful discount.
      const match=(cart.discount_codes||[]).find(item=>item.code?.toLowerCase()===code.toLowerCase());
      if(feedbackCoupon)feedbackCoupon.textContent=match?.applicable===false?'Este cupom não é aplicável aos itens atuais.':match?.applicable===true?'Cupom aplicado! Confira o total antes de pagar.':'Cupom enviado à Shopify. Confirme as condições no checkout.';
    }catch(error){
      if(feedbackCoupon)feedbackCoupon.textContent=error.message||'Não foi possível aplicar. Você também pode inserir o cupom no checkout.';
    }finally{if(btn)btn.disabled=false;}
  });
})();
